import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { Loader, BaasicInput } from 'core/components';

const DuplicateReportTemplate = ({ t, duplicateReportViewStore: { loading, form, modalParams } }) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('REPORTS.MODAL.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<p className="spc--bottom--sml">{t('REPORTS.MODAL.MESSAGE')}</p>
					<BaasicInput field={form.$('name')} />
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--right--sml spc--bottom--sml" type="submit">
						{t('SAVE')}
					</button>
					<button className="btn btn--med btn--outline spc--bottom--sml" type="button" onClick={modalParams.close}>
						{t('CANCEL')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(DuplicateReportTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/DuplicateReportTemplate.jsx